import { supabase } from '../supabaseClient';
import { mapDelivery } from '../lib/helpers';

const toDb = (d, includeId = true) => {
  const row = {
    linked_request_id:  d.linkedRequestId  || d.linked_request_id  || null,
    asset_ids:          d.assetIds         || d.asset_ids          || [],
    asset_names:        d.assetNames       || d.asset_names,
    from_facility_id:   d.fromFacilityId   || d.from_facility_id,
    from_facility_name: d.fromFacilityName || d.from_facility_name,
    to_facility_id:     d.toFacilityId     || d.to_facility_id,
    to_facility_name:   d.toFacilityName   || d.to_facility_name,
    carrier:            d.carrier,
    tracking_no:        d.trackingNo       || d.tracking_no,
    status:             d.status,
    priority:           d.priority,
    created_by:         d.createdBy        || d.created_by,
    created_at:         d.createdAt        || d.created_at         || new Date().toISOString(),
    dispatched_at:      d.dispatchedAt     || d.dispatched_at      || null,
    delivered_at:       d.deliveredAt      || d.delivered_at       || null,
    estimated_delivery: d.estimatedDelivery|| d.estimated_delivery || null,
    notes:              d.notes,
    items:              d.items            || 1,
    org_id:             d.org_id           || d.orgId,
  };
  if (includeId && d.id) row.id = d.id;
  return row;
};

export const deliveriesService = {

  async getAll() {
    const { data, error } = await supabase
      .from('deliveries')
      .select('*')
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data.map(mapDelivery);
  },

  async create(delivery) {
    const { data, error } = await supabase
      .from('deliveries')
      .insert([toDb(delivery, false)])
      .select()
      .single();
    if (error) throw error;
    return mapDelivery(data);
  },

  async update(id, changes) {
    const dbChanges = {
      ...(changes.status             !== undefined && { status:             changes.status }),
      ...(changes.tracking_no        !== undefined && { tracking_no:        changes.tracking_no }),
      ...(changes.trackingNo         !== undefined && { tracking_no:        changes.trackingNo }),
      ...(changes.dispatched_at      !== undefined && { dispatched_at:      changes.dispatched_at }),
      ...(changes.dispatchedAt       !== undefined && { dispatched_at:      changes.dispatchedAt }),
      ...(changes.delivered_at       !== undefined && { delivered_at:       changes.delivered_at }),
      ...(changes.deliveredAt        !== undefined && { delivered_at:       changes.deliveredAt }),
      ...(changes.estimated_delivery !== undefined && { estimated_delivery: changes.estimated_delivery }),
      ...(changes.estimatedDelivery  !== undefined && { estimated_delivery: changes.estimatedDelivery }),
      ...(changes.notes              !== undefined && { notes:              changes.notes }),
      ...(changes.carrier            !== undefined && { carrier:            changes.carrier }),
    };
    const { data, error } = await supabase
      .from('deliveries')
      .update(dbChanges)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async updateStatus(id, status, extra = {}) {
    const update = { status, ...extra };
    const { data, error } = await supabase
      .from('deliveries')
      .update(update)
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return mapDelivery(data);
  },

  async delete(id) {
    const { error } = await supabase.from('deliveries').delete().eq('id', id);
    if (error) throw error;
  },
};
